import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useOnline } from '@vueuse/core'

export const useNetworkStore = defineStore('network', () => {
    const isOnline = useOnline()
    const networkError = ref(false)

    function showNetworkError() {
        networkError.value = true
    }

    function clearNetworkError() {
        networkError.value = false
    }

    return { isOnline, networkError, showNetworkError, clearNetworkError }
})
